export default __webpack_public_path__ + "static/media/02_Landscape__4_gekuerzt.3c5808be.mp3";